import { useState, useEffect } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useHomePage = () => {
  const [dishes, setDishes] = useState([]);
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(false);
  const { authed, token } = useAuth();

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
    };
    if (authed) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(`${apiRoot}/homepage`, {
      headers
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setDishes(json.dishes);
            setEvents(json.events);
            setError(false);
          });
        } else {
          setError(true);
          setDishes([]);
          setEvents([]);
        }
      })
      .catch((err) => {
        setError(true);
        setDishes([]);
        setEvents([]);
      });
  }, [authed, token]);

  return {
    dishes,
    events,
    error,
  };
};

export default useHomePage;
